import * as featureFlags from '@attain-apps/feature-flags'
import * as userPoolInfo from '@attain-apps/infra-env/user-pools/develop.json'

import type { AtnEnvironment } from './interface'

export const environment: AtnEnvironment = {
  auth: {
    ...userPoolInfo,
    providerUrl: 'auth.dev.attainapps.com',
  },
  baseHref: '/',
  featureFlags: featureFlags.EXPERIMENTAL,
  graphqlEndpoint: 'https://api.dev.attainapps.com/graphql',
  production: false,
}
